import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Account from "./pages/Account";
import AuthCallback from "./components/AuthCallback";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // Synchronous check: process session_id from OAuth callback before any route renders
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/account" element={<Account />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
